export default __webpack_public_path__ + "static/media/award.8b53907d.png";